import $ from 'jquery';
import 'slick-carousel'; 
import 'slick-carousel/slick/slick.css';
import { gsap, TweenLite, TweenMax, MotionPathPlugin, ScrollToPlugin, ScrollTrigger } from "gsap/all";

gsap.registerPlugin(TweenLite, TweenMax, MotionPathPlugin, ScrollToPlugin, ScrollTrigger); 

const catalog = {};

catalog.catalogSlider = function() {
    const slider = $('.catalog-slider');
    slider.slick({
        arrows: true,
        dots: false,
        speed:1000,
        infinite: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: '<div class="arrow-next"> \
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"> \
                            <g id="ico-arrow-circle_right" data-name="ico-arrow-circle=right" transform="translate(-598 -3023)"> \
                                <circle id="Ellipse_40" data-name="Ellipse 40" cx="12" cy="12" r="12" transform="translate(598 3023)" fill="#73a37c"/> \
                                <g id="right-arrow_1_" data-name="right-arrow(1)" transform="translate(504.522 3028.198)"> \
                                    <g id="Group_1756" data-name="Group 1756" transform="translate(101.478)"> \
                                        <path id="Path_24911" data-name="Path 24911" d="M109.176,6.209,103.182.215a.738.738,0,0,0-1.042,0L101.7.656a.738.738,0,0,0,0,1.042l5.033,5.033-5.038,5.038a.738.738,0,0,0,0,1.042l.441.441a.738.738,0,0,0,1.042,0l6-6a.744.744,0,0,0,0-1.046Z" transform="translate(-101.478)" fill="#fff"/> \
                                    </g> \
                                </g> \
                            </g> \
                        </svg> \
                    </div>',
        prevArrow: '<div class="arrow-prev"> \
                        <svg id="ico-arrow-circle_left" data-name="ico-arrow-circle=left" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"> \
                            <circle id="Ellipse_40" data-name="Ellipse 40" cx="12" cy="12" r="12" fill="#73a37c"/> \
                            <g id="right-arrow_1_" data-name="right-arrow(1)" transform="translate(8.087 5.198)"> \
                                <g id="Group_1756" data-name="Group 1756"> \
                                    <path id="Path_24911" data-name="Path 24911" d="M101.693,6.209,107.686.215a.738.738,0,0,1,1.042,0l.441.441a.738.738,0,0,1,0,1.042l-5.033,5.033,5.038,5.038a.738.738,0,0,1,0,1.042l-.441.441a.738.738,0,0,1-1.042,0l-6-6a.744.744,0,0,1,0-1.046Z" transform="translate(-101.478)" fill="#fff"/> \
                                </g> \
                            </g> \
                        </svg> \
                    </div>',
    });
}

catalog.init = function() {
    catalog.catalogSlider();
}

catalog.init();